export default __webpack_public_path__ + "static/media/householdChores.e8d1bb12.svg";